import { defineMessages } from 'react-intl';

export const createSnippetModalMessages: {
	titleCreate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	successFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	syncBlockSourceWarning: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	titleCreate: {
		id: 'snippets.snippetEditorModal.titleCreate',
		defaultMessage: 'Create block template',
		description: 'Title for the create block template modal',
	},
	createButton: {
		id: 'snippets.snippetEditorModal.createButton',
		defaultMessage: 'Create',
		description:
			'The text is shown on the primary submit button in the Create Block Template modal. When the user clicks this button, it saves and creates the new block template.',
	},
	successFlagTitle: {
		id: 'snippets.snippetEditorModal.successFlagTitle',
		defaultMessage: 'Template "{snippetName}" created',
		description: 'Title for the success flag shown when template creation succeeds',
	},
	errorFlagTitle: {
		id: 'snippets.snippetEditorModal.errorFlagTitle',
		defaultMessage: 'Could not create template',
		description: 'Title for the error flag shown when template creation fails',
	},
	errorFlagDescription: {
		id: 'snippets.snippetEditorModal.errorFlagDescription',
		defaultMessage: 'Please try again',
		description: 'Description for the error flag shown when template creation fails',
	},
	syncBlockSourceWarning: {
		id: 'snippets.snippetEditorModal.syncBlockSourceWarning',
		defaultMessage:
			'This will create a new block template. If you want to reference the existing content, insert a sync block reference instead.',
		description:
			'Warning shown in the create modal when the user is attempting to save a source sync block as a template',
	},
});
